import { render, staticRenderFns } from "./searchHeading.vue?vue&type=template&id=070f568a&scoped=true&"
import script from "./searchHeading.vue?vue&type=script&lang=js&"
export * from "./searchHeading.vue?vue&type=script&lang=js&"
import style0 from "./searchHeading.vue?vue&type=style&index=0&id=070f568a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f568a",
  null
  
)

export default component.exports